import React, { useContext } from "react";
import { Context } from "@/contexts/AuthContext";
import Protected from "./security/";
import LayoutCommon from "./common/";

import Routes from "@/routes/index";

export const Layout = () => {
	const { authenticated } = useContext(Context);

	if (authenticated) {
		return (
			<Protected>
				<Routes />
			</Protected>
		);
	}

	return (
		<LayoutCommon>
			<Routes />
		</LayoutCommon>
	);
};

export default Layout;
